import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import MessageUI from '../../widgets/output/MessageUI'
import ButtonUI from '../../widgets/action/ButtonUI'
import PublicPageSF from '../../templates/PublicPageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'

const SocialUserEmailPageUI = ({context, privacy, messageList, provider, onReRequest}) =>
  <PublicPageSF context={context} className='pg_email_req' backLink='/'
    messageList={messageList} headerMessageKey='c_email_required' headerMessageArgs={[provider]}
  >
    <PageTitleUI context={context}
      messageList={messageList} titleMessageKey='c_email_required' titleMessageArgs={[provider]}
    />
    <CardUI>
      <MessageUI
        messageList={messageList}
        messageKey='c_fb_email_req_ms'
        args={[context.session.appName, provider]}
      />
      <div className='g_text_right g_m_top_100'>
        <ButtonUI messageList={messageList} labelKey='c_provide_email' onClick={onReRequest} />
      </div>
    </CardUI>
  </PublicPageSF>

export default SocialUserEmailPageUI
